<template>
	<div>
		<b-row class="print-row mt-3">
			<b-col>
				<h4 class="avoid-page-break-after">Theme</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(levelData, level) in themeLevels" :key="'details-abilities-theme-'+level">
			<b-col cols="2">
				<strong>{{levelData.Theme.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre" v-if="levelData.Theme != undefined">
				{{levelData.Theme.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		themeLevels: function(){
			var levels = {}
			var previousLevels = this.$store.getters.previousLevels
			for(const level in previousLevels){
				if(previousLevels[level].Theme){
					levels[level] = previousLevels[level]
				}
			}
			return levels
		}
	}
}
</script>

<style scoped>

</style>